import React, { useState } from 'react';
import ReactModal from 'react-modal';
import Loading from 'ui/components/overlay/Loading';
import { rootElement } from 'app/constants';
import { ConfirmProps } from 'ui/models/overlay';
import Confirm from 'ui/components/overlay/Confirm';

/**
 * It is important for users of screenreaders that other page content be
 * hidden (via the aria-hidden attribute) while the modal is open.
 *
 * http://reactcommunity.org/react-modal/accessibility/#app-element
 */
ReactModal.setAppElement(document.getElementById(rootElement.id) as HTMLElement);

export const useOverlay = () => {
  const [isVisible, setIsVisible] = useState(false);

  const openModal = () => setIsVisible(true);
  const closeModal = () => setIsVisible(false);

  const RenderConfirm = ({
    title,
    text,
    variant,
    canClose = true,
    ...props
  }: ConfirmProps) => (
    <Confirm
      isOpen={isVisible}
      onCloseModal={closeModal}
      contentLabel={title}
      variant={variant}
      contentMessage={text}
      shouldCloseOnOverlayClick={canClose}
      shouldCloseOnEsc={canClose}
      {...props}
    />
  );

  const RenderLoading = () => (
    <Loading isOpen={isVisible} onCloseModal={closeModal} />
  );

  return {
    openModal,
    closeModal,
    RenderConfirm,
    RenderLoading,
  };
};
